// Severity classification for an hour against the current period high.
// Thresholds: >=95% of high = DANGER, 90-95% = WARNING, else normal.
// The asymmetric cost (missing a peak is expensive, false alarms are cheap)
// motivates being generous on the danger side.

export const DANGER_THRESHOLD = 0.95;
export const WARNING_THRESHOLD = 0.90;

export function classifySeverity(value, high) {
  if (high == null || high === 0 || value == null) return 'normal';
  const pct = value / high;
  if (pct >= DANGER_THRESHOLD) return 'danger';
  if (pct >= WARNING_THRESHOLD) return 'warning';
  return 'normal';
}

export function pctOfHigh(value, high) {
  if (high == null || high === 0 || value == null) return null;
  return value / high;
}

export const SEVERITY = {
  danger:  { label: 'DANGER',  bg: '#d32f2f', fg: '#fff', rank: 2 },
  warning: { label: 'WARNING', bg: '#f9a825', fg: '#000', rank: 1 },
  normal:  { label: 'OK',      bg: '#2e7d32', fg: '#fff', rank: 0 },
};
